import { render, staticRenderFns } from "./ElementTimer.vue?vue&type=template&id=712c2bfe&"
import script from "./ElementTimer.vue?vue&type=script&lang=js&"
export * from "./ElementTimer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports